<app-loading-spinner
  *ngIf="isLoading"
  class="spinner-full-page"
/>

<div class="nav-bar">
  <div>
    <h1>ZippMat Customer Portal</h1>
    <p>Orders, documents, and invoices — all in one place</p>
  </div>
  <div class="action-buttons">
    <mat-button-toggle-group
      class="switch-toggle"
      [value]="buttonToggleOptions"
      [hideSingleSelectionIndicator]="true"
      (change)="onValChange($event.value)"
    >
      <mat-button-toggle value="orders">Orders</mat-button-toggle>
      <mat-button-toggle value="payments">Payments</mat-button-toggle>
    </mat-button-toggle-group>

    <button
      mat-stroked-button
      class="logout-btn"
      (click)="onLogout()"
    >
      <span class="material-icons"> logout </span>
      Logout
    </button>
  </div>
</div>

<div
  class="container"
  *ngIf="!isLoading"
>
  <div
    class="heading"
    style="display: flex; align-items: center; justify-content: center; text-align: center"
  >
    <img
      [src]="customerInfo.logoImageUrl"
      *ngIf="customerInfo.logoImageUrl !== null"
      alt="Customer Logo"
      height="90px"
    />

    <span style="max-width: 50%; margin-left: 50px; text-align: left; font-size: 24px; font-weight: bold">
      {{ customerInfo.name }}
    </span>
  </div>

  <!-- <div
    id="highlight-tiles"
    class="grid-display-4"
    style="gap: 50px"
  >
    <div class="tile">
      <b>{{ highlightStatementTiles.totalTransactionAmount }}</b>
      Total Relationship Value
    </div>

    <div class="tile">
      <b>{{ highlightStatementTiles.numberOfMonths }}</b>

      Months of Business
    </div>

    <div class="tile">
      <b>{{ highlightStatementTiles.numberOfProducts }}+</b>

      Number Of Products
    </div>

    <div class="tile">
      <b>{{ highlightStatementTiles.numberOfDeliverySites }}</b>

      Delivery Sites
    </div>
  </div> -->

  <!-- <button
    class="aging-report-button"
    mat-flat-button
    (click)="onAgingReportClick()"
  >
    <b>Repayment Report</b>
  </button> -->

  <div
    class="order-container"
    *ngIf="buttonToggleOptions === 'orders'"
  >
    <div class="filter-container">
      <h3>Filter</h3>

      <form
        [formGroup]="searchForm"
        class="search-form"
      >
        <app-selection-input
          [control]="$any(searchForm.get('dateRange'))"
          [options]="filteredOptions['dateRange']"
          (selectedOption)="applyOrderFilter()"
        >
        </app-selection-input>

        <app-autocomplete-backend-input
          label="PO Number"
          placeholder="PO Number"
          [control]="$any(searchForm.get('poNumber'))"
          [options]="filteredOptions['poNumber']"
          [noSelection]="true"
          (selectionChanged)="applyOrderFilter()"
          (searchStringChange)="onPoNumberStringChange($event)"
        >
        </app-autocomplete-backend-input>

        <app-autocomplete-backend-input
          label="Project"
          placeholder="Project"
          [control]="$any(searchForm.get('project'))"
          [options]="filteredOptions['project']"
          [noSelection]="true"
          (selectionChanged)="applyOrderFilter()"
          (searchStringChange)="onProjectStringChange($event)"
        >
        </app-autocomplete-backend-input>

        <app-autocomplete-backend-input
          label="Category / Product"
          placeholder="Category / Product"
          [control]="$any(searchForm.get('categoryProduct'))"
          [options]="filteredOptions['categoryProduct']"
          [noSelection]="true"
          (selectionChanged)="applyOrderFilter()"
          (searchStringChange)="onCategoryProductStringChange($event)"
        >
        </app-autocomplete-backend-input>
      </form>
    </div>
    <div class="table-container">
      <div class="order-type-options">
        <mat-chip-listbox
          [multiple]="false"
          (change)="setOrderType($event.value)"
          [formControl]="$any(searchForm.get('orderType'))"
        >
          <mat-chip-option
            *ngFor="let option of orderTypeOptions"
            [value]="option.key"
          >
            {{ option.value }}
          </mat-chip-option>
        </mat-chip-listbox>
      </div>
      <div class="order-table-container">
        <app-loading-spinner *ngIf="orderDataLoader" />
        <table
          mat-table
          [dataSource]="orderDataSource"
        >
          <ng-container matColumnDef="enquiryNum">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              Order ID
            </th>
            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.enquiryNum }}
            </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              Order Date
            </th>
            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.date }}
            </td>
          </ng-container>

          <ng-container matColumnDef="poNumber">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              PO Number
            </th>
            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.poNumber }}
            </td>
          </ng-container>

          <ng-container matColumnDef="items">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              Items
            </th>
            <td
              mat-cell
              matTooltipClass="tooltip"
              [matTooltip]="row.itemList"
              *matCellDef="let row"
            >
              {{ row.items }}
            </td>
          </ng-container>

          <ng-container matColumnDef="project">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              Project
            </th>
            <td
              mat-cell
              [matTooltip]="row.projectAddress"
              *matCellDef="let row"
            >
              {{ row.project }}
            </td>
          </ng-container>

          <ng-container matColumnDef="quotationAmt">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              Quotation Amt
            </th>
            <td
              mat-cell
              *matCellDef="let row"
            >
              ₹ {{ row.quotationAmt }}
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="orderTableColumns"
          ></tr>
          <tr
            mat-row
            (click)="navigateToOrderPage(row.id)"
            *matRowDef="let row; columns: orderTableColumns"
          ></tr>
          <tr
            *matNoDataRow
            class="data-not-found"
          >
            No orders found matching the selected filters
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div *ngIf="buttonToggleOptions === 'payments'">
    <div
      id="highlight-tiles"
      class="grid-display-4"
      style="gap: 50px"
    >
      <div class="tile">
        Total Outstanding
        <b>₹ {{ agingReport.outstanding }}</b>
      </div>
      <div class="tile">
        Not Due
        <b>₹ {{ agingReport.notDue }}</b>
      </div>
      <div class="tile">
        Total Due
        <b>₹ {{ agingReport.due }}</b>
      </div>
      <div class="tile">
        <button
          mat-button
          (click)="downloadZohoCustomerStatement()"
          [disabled]="downloadZohoCustomerStatementButtonLoading"
        >
          <app-loading-spinner-button *ngIf="downloadZohoCustomerStatementButtonLoading"></app-loading-spinner-button>
          <span
            *ngIf="!downloadZohoCustomerStatementButtonLoading"
            class="material-icons"
          >
            download
          </span>
        </button>
        <b>Download Ledger</b>
      </div>
    </div>

    <div class="mat-elevation-z8 payment-table-container">
      <div>
        <h3>Outstanding Invoices</h3>
        <p>Invoices pending payment</p>
      </div>

      <app-loading-spinner *ngIf="outstandingInvoiceDataLoader" />
      <table
        mat-table
        [dataSource]="invoiceDataSource"
      >
        <ng-container matColumnDef="id">
          <th
            mat-header-cell
            *matHeaderCellDef
          >
            Invoice ID
          </th>
          <td
            mat-cell
            *matCellDef="let row"
          >
            {{ row.invoiceNo }}
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th
            mat-header-cell
            *matHeaderCellDef
          >
            Invoice Date
          </th>
          <td
            mat-cell
            *matCellDef="let row"
          >
            {{ row.invoiceDate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dueDate">
          <th
            mat-header-cell
            *matHeaderCellDef
          >
            Due Date
          </th>
          <td
            mat-cell
            *matCellDef="let row"
          >
            {{ row.dueDate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th
            mat-header-cell
            *matHeaderCellDef
          >
            Amount
          </th>
          <td
            mat-cell
            *matCellDef="let row"
          >
            ₹ {{ row.amount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="outstanding">
          <th
            mat-header-cell
            *matHeaderCellDef
          >
            Outstanding
          </th>
          <td
            mat-cell
            *matCellDef="let row"
          >
            ₹ {{ row.outstanding }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dpd">
          <th
            mat-header-cell
            *matHeaderCellDef
          >
            Days Past Due
          </th>
          <td
            mat-cell
            *matCellDef="let row"
          >
            <div
              class="due-chip"
              [ngClass]="{ overdue: row.daysPastDue > 0, 'not-due': row.daysPastDue <= 0 }"
            >
              <mat-icon *ngIf="row.daysPastDue > 0">error_outline</mat-icon>
              {{ row.daysPastDue > 0 ? row.daysPastDue + " days" : "Not Due" }}
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="outstandingPaymentsTableColumns"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: outstandingPaymentsTableColumns"
        ></tr>
        <tr
          *matNoDataRow
          class="data-not-found"
        >
          No invoice found
        </tr>
      </table>

      <mat-paginator
        #invoicePaginator
        [hidePageSize]="true"
        [pageSize]="outstandingInvoicePageSize"
        (page)="onChangePage($event)"
        [length]="totalOutstandingInvoicesDataLength"
      />
    </div>
  </div>
</div>
